module.exports = __webpack_public_path__ + "img/mask4.ebc08a8f.jpeg";